export default {
  palette: {
    type: 'light'
  },
  navigation: { topBar: { text: '#fff', background: 'rgba(55,55,55,0.9)' } }
};
